import React from 'react';
import { Link } from 'react-router-dom';
import { useJWTAuth } from '../JWTAuthContext';

const QuickActions: React.FC = () => {
  const { user } = useJWTAuth();
  return (
    <div className="row g-4">
      <div className="col-md-8">
        <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
          <div className="card-header bg-transparent border-0 p-4">
            <h5 className="fw-bold mb-0">
              <i className="fas fa-rocket me-2 text-primary"></i>
              Quick Actions
            </h5>
          </div>
          <div className="card-body p-4">
            <div className="row g-3">
              <div className="col-md-4">
                <Link 
                  to="/pyq-history" 
                  className="btn btn-outline-purple btn-lg w-100 py-3"
                  style={{ borderRadius: '12px', borderColor: '#6f42c1', color: '#6f42c1' }}>
                  <i className="fas fa-archive me-2"></i>
                  PYQ
                </Link>
              </div>
              <div className="col-md-4">
                <Link 
                  to="/mock-test" 
                  className="btn btn-outline-primary btn-lg w-100 py-3"
                  style={{ borderRadius: '12px' }}>
                  <i className="fas fa-edit me-2"></i>
                  Take Mock Test
                </Link>
              </div>
              <div className="col-md-4">
                <Link 
                  to="/custom-quiz-history" 
                  className="btn btn-outline-info btn-lg w-100 py-3"
                  style={{ borderRadius: '12px' }}>
                  <i className="fas fa-cog me-2"></i>
                  Custom Quiz
                </Link>
              </div>
              {user && (user.id === "258" || user.id === "257") && <div className="col-md-4">
                <Link 
                  to="/study-plan" 
                  className="btn btn-outline-danger btn-lg w-100 py-3"
                  style={{ borderRadius: '12px' }}>
                  <i className="fas fa-calendar-plus me-2"></i>
                  Study Plan
                </Link>
              </div>}
              {/* <div className="col-md-4">
                <Link 
                  to="/ai-tutor" 
                  className="btn btn-outline-success btn-lg w-100 py-3"
                  style={{ borderRadius: '12px' }}>
                  <i className="fas fa-microphone-alt me-2"></i>
                  Ask WiziTalk
                </Link>
              </div> */}
              <div className="col-md-4">
                <Link 
                  to="/performance" 
                  className="btn btn-outline-warning btn-lg w-100 py-3"
                  style={{ borderRadius: '12px' }}>
                  <i className="fas fa-chart-bar me-2"></i>
                  Performance
                </Link>
              </div>
              <div className="col-md-4">
                <Link 
                  to="/report-card" 
                  className="btn btn-outline-secondary btn-lg w-100 py-3"
                  style={{ borderRadius: '12px' }}>
                  <i className="fas fa-file-alt me-2"></i>
                  Report Card
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
          <div className="card-header bg-transparent border-0 p-4">
            <h5 className="fw-bold mb-0">
              <i className="fas fa-calendar-alt me-2 text-primary"></i>
              Study Plan : Today's Goal
            </h5>
          </div>
          <div className="card-body p-4">
            <div className="text-center">
              {/* Commented out for now - Coming Soon
              <div className="position-relative d-inline-flex align-items-center justify-content-center mb-3"
                style={{ width: '100px', height: '100px' }}>
                <svg className="position-absolute" width="100" height="100">
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke="#e9ecef"
                    strokeWidth="8"
                    fill="none"
                  />
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke="#667eea"
                    strokeWidth="8"
                    fill="none"
                    strokeDasharray="283"
                    strokeDashoffset="85"
                    strokeLinecap="round"
                    style={{ transition: 'stroke-dashoffset 0.5s ease' }}
                  />
                </svg>
                <span className="fw-bold fs-4">70%</span>
              </div>
              <p className="text-muted mb-3">Daily Progress</p>
              <small className="text-success">
                <i className="fas fa-check-circle me-1"></i>
                7 out of 10 questions completed
              </small>
              */}
              
              {/* Coming Soon Message */}
              <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '140px' }}>
                <i className="fas fa-clock text-muted mb-3" style={{ fontSize: '3rem', opacity: '0.5' }}></i>
                <h6 className="text-muted mb-2">Coming Soon</h6>
                <p className="text-muted text-center small mb-0">
                  Study Plan: Daily goal tracking and progress insights will be available soon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;